export const isValidDateFormat = (date: string): boolean =>
  /^\d{4}-\d{2}-\d{2}$/.test(date);

export const isValidTimeFormat = (time: string): boolean =>
  /^\d{2}:\d{2}:\d{2}$/.test(time);

export const isValidDateTimeFormat = (dateTime: string): boolean =>
  /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/.test(dateTime);
